/**
 * Hides the PDP mobile fixed buy-buttons bar when the footer scrolls into view.
 * (Theme sticky-add-to-cart is hidden via CSS; this handles the custom fixed bar.)
 */
(function () {
  const main = document.querySelector('main[data-template*="product"]');
  if (!main) return;

  const bar = document.querySelector(
    '.product-information[data-testid="product-information"] .product-form-buttons__actions'
  );
  if (!bar) return;

  const footer = document.querySelector('footer') ?? document.querySelector('[class*="footer-group"]');
  if (!footer) return;

  const cls = 'pdp-buy-bar-hidden-by-footer';

  const io = new IntersectionObserver(
    (entries) => {
      const [entry] = entries;
      if (!entry) return;
      document.body.classList.toggle(cls, entry.isIntersecting);
    },
    {
      threshold: 0,
      rootMargin: '0px 0px 80px 0px',
    }
  );

  io.observe(footer);
})();
